import React, { Component } from 'react';
import axios from 'axios';
import browserHistory from '../../history';
import Header from '../authentication/Header';
import Footer from '../authentication/Footer';

const TABS = [
    { key: 'personal',    label: 'Personal' },
    { key: 'company',     label: 'Company' },
    { key: 'team',        label: 'Team' },
    { key: 'addresses',   label: 'Addresses' },
    { key: 'paymentinfo', label: 'Payment Info' },
    { key: 'graphics',    label: 'Graphics' },
    { key: 'social',      label: 'Social' },
    { key: 'promolinks',  label: 'Promo Links' },
];

const RESTRICTED_TABS = ['company', 'team', 'addresses', 'paymentinfo', 'graphics', 'social', 'promolinks'];

function getConfig() {
    const siteConfig = (window.site && window.site.config) || {};
    return {
        commonApi:           siteConfig.commonApi          || siteConfig.commonResourcesUrl || '',
        submissionLambdaUrl: siteConfig.submissionApi      || siteConfig.screeningApi       || '',
        screeningApi:        siteConfig.screeningApi       || '',
        appname:             (window.app && window.app.appName)    || '',
        env:                 (window.app && window.app.appEnvName) || 'dev',
    };
}

function getToken() {
    const appStorage = (window.app && window.app.storage) || {};
    return (appStorage.getItem && appStorage.getItem('token')) || localStorage.getItem('token') || sessionStorage.getItem('token') || '';
}

// ─── Styles ──────────────────────────────────────────────────────────────────
const S = {
    page: { minHeight: 'calc(100vh - 180px)', backgroundColor: 'var(--mainbgColor, #0d0d1f)', color: '#ffffff', paddingTop: '60px' },
    tabBar: { borderBottom: '1px solid rgba(255,255,255,0.1)', display: 'flex', gap: '0', overflowX: 'auto', padding: '0 32px', position: 'sticky', top: '60px', zIndex: 100, backgroundColor: 'var(--secbgColor, #1e222b)' },
    tabBtn: (active) => ({
        padding: '14px 20px', background: 'none', border: 'none',
        borderBottom: active ? '2px solid var(--highlight, #e9c548)' : '2px solid transparent',
        color: active ? 'var(--highlight, #e9c548)' : '#aaaaaa',
        fontWeight: active ? '700' : '400', fontSize: '14px', cursor: 'pointer',
        whiteSpace: 'nowrap', letterSpacing: '0.3px', transition: 'color 0.2s, border-color 0.2s',
    }),
    body: { maxWidth: '960px', margin: '0 auto', padding: '32px 24px' },
    headerRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
    h1: { fontSize: '22px', fontWeight: '700', margin: 0 },
    backBtn: { display: 'flex', alignItems: 'center', gap: '6px', padding: '8px 20px', background: 'transparent', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '20px', color: '#ffffff', cursor: 'pointer', fontSize: '13px', fontWeight: '600', letterSpacing: '1px' },
    sectionTitle: { fontSize: '16px', fontWeight: '700', color: '#ffffff', marginBottom: '24px', paddingBottom: '10px', borderBottom: '1px solid rgba(255,255,255,0.1)' },
    subTitle: { fontSize: '14px', fontWeight: '600', color: 'var(--highlight, #e9c548)', marginBottom: '16px', marginTop: '24px' },
    row: { display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px', marginBottom: '20px' },
    row2: { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '20px', marginBottom: '20px' },
    rowFull: { display: 'grid', gridTemplateColumns: '1fr', gap: '20px', marginBottom: '20px' },
    field: { display: 'flex', flexDirection: 'column', gap: '6px' },
    label: { fontSize: '13px', color: '#aaaaaa' },
    input: { width: '100%', padding: '10px 14px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', color: '#ffffff', fontSize: '14px', outline: 'none', boxSizing: 'border-box' },
    select: { width: '100%', padding: '10px 14px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', color: '#ffffff', fontSize: '14px', outline: 'none', appearance: 'none', boxSizing: 'border-box', cursor: 'pointer' },
    textarea: { width: '100%', padding: '10px 14px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', color: '#ffffff', fontSize: '14px', outline: 'none', resize: 'vertical', minHeight: '120px', boxSizing: 'border-box' },
    phoneRow: { display: 'flex', gap: '8px' },
    codeSelect: { width: '110px', flexShrink: '0', padding: '10px 8px', background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', color: '#ffffff', fontSize: '13px', outline: 'none', appearance: 'none', cursor: 'pointer' },
    required: { color: '#ff5555', marginLeft: '3px' },
    saveRow: { display: 'flex', justifyContent: 'flex-end', paddingTop: '12px', marginBottom: '32px' },
    saveBtn: { padding: '10px 28px', background: 'var(--highlight, #e9c548)', border: 'none', borderRadius: '4px', color: '#15171b', fontWeight: '700', fontSize: '14px', cursor: 'pointer', letterSpacing: '0.5px' },
    divider: { border: 'none', borderTop: '1px solid rgba(255,255,255,0.08)', margin: '28px 0' },
    modal: { position: 'fixed', inset: '0', background: 'rgba(0,0,0,0.75)', zIndex: '9999', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '16px' },
    modalBox: { background: 'var(--secbgColor, #1e222b)', border: '1px solid rgba(255,255,255,0.15)', borderRadius: '8px', padding: '28px', maxWidth: '400px', width: '100%' },
    modalTitle: { fontSize: '18px', fontWeight: '700', marginBottom: '14px' },
    modalBody: { fontSize: '14px', color: '#cccccc', marginBottom: '24px', lineHeight: '1.6' },
    modalFooter: { display: 'flex', gap: '10px', justifyContent: 'flex-end' },
    btnSecondary: { padding: '8px 18px', background: 'rgba(255,255,255,0.1)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: '6px', color: '#ffffff', cursor: 'pointer', fontSize: '13px' },
    btnPrimary: { padding: '8px 18px', background: 'var(--highlight, #e9c548)', border: 'none', borderRadius: '6px', color: '#15171b', fontWeight: '700', cursor: 'pointer', fontSize: '13px' },
    btnDanger: { padding: '6px 14px', background: '#dc2626', border: 'none', borderRadius: '6px', color: '#ffffff', fontWeight: '600', cursor: 'pointer', fontSize: '12px' },
    toast: (show, type) => ({
        position: 'fixed', bottom: '32px', left: '50%',
        transform: `translateX(-50%) translateY(${show ? '0' : '80px'})`,
        opacity: show ? 1 : 0, background: type === 'error' ? '#dc2626' : '#16a34a',
        color: '#ffffff', padding: '12px 24px', borderRadius: '8px', fontSize: '14px',
        fontWeight: '600', zIndex: '99999', transition: 'all 0.3s ease',
        pointerEvents: 'none', whiteSpace: 'nowrap',
    }),
    uploadBox: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '32px', border: '2px dashed rgba(255,255,255,0.2)', borderRadius: '8px', background: 'rgba(255,255,255,0.03)', cursor: 'pointer', textAlign: 'center', gap: '8px' },
    promoTable: { width: '100%', borderCollapse: 'collapse', marginTop: '16px', fontSize: '13px' },
    promoTh: { padding: '10px 12px', background: 'rgba(255,255,255,0.06)', color: '#aaaaaa', textAlign: 'left', fontWeight: '600', borderBottom: '1px solid rgba(255,255,255,0.1)' },
    promoTd: { padding: '10px 12px', borderBottom: '1px solid rgba(255,255,255,0.06)', color: '#dddddd', verticalAlign: 'middle' },
};

// ─── Main Component ───────────────────────────────────────────────────────────
class CreatorPage extends Component {
    constructor(props) {
        super(props);
        const _appStorage = (window.app && window.app.storage) || {};
        const _savedId = localStorage.getItem('creator_user_id');
        const _loggedInType = (_appStorage.getItem && _appStorage.getItem('usertype')) || localStorage.getItem('usertype');
        const _loggedInUid  = (_appStorage.getItem && _appStorage.getItem('uid'))      || localStorage.getItem('uid');
        const _initialUid = _savedId || (_loggedInType === 'creator' ? _loggedInUid : null);
        this.state = {
            activeTab: 'personal',
            createdUserId: _initialUid || null,
            showUserRequiredModal: false,
            showSuccessModal: false,
            successEmail: '',
            toast: { show: false, message: '', type: '' },
            // Personal form
            form: {
                firstName: '', lastName: '', companyName: '', email: '',
                address: '', city: '', country: '', state: '', postalCode: '',
                homePhoneDialingCode: '', homePhone: '', mobileDialingCode: '', mobileNumber: '',
                dateOfBirth: '', ethnicity: '', gender: '', creatorType: '', jobType: '',
                description: '', status: 'active', promoLink: '',
            },
            // Company tab
            company: { address: '', city: '', state: '', country: '', postalCode: '', email: '', officePhoneDialingCode: '', officePhone: '', mobileDialingCode: '', mobileNumber: '' },
            companyRegions: [],
            loadingCompanyRegions: false,
            // Team tab
            team: {
                talentAgentName: '', talentAgentAddress: '', talentAgentCity: '', talentAgentState: '', talentAgentCountry: '', talentAgentPostalCode: '', talentAgentPhoneDialingCode: '', talentAgentPhoneNumber: '', talentAgentMobileDialingCode: '', talentAgentMobileNumber: '', talentAgentEmail: '',
                talentManagerName: '', talentManagerAddress: '', talentManagerCity: '', talentManagerState: '', talentManagerCountry: '', talentManagerPostalCode: '', talentManagerPhoneDialingCode: '', talentManagerPhoneNumber: '', talentManagerMobileDialingCode: '', talentManagerMobileNumber: '', talentManagerEmail: '',
                publicistName: '', publicistAddress: '', publicistCity: '', publicistState: '', publicistCountry: '', publicistPostalCode: '', publicistPhoneDialingCode: '', publicistPhoneNumber: '', publicistMobileDialingCode: '', publicistMobileNumber: '', publicistEmail: '',
                legalRepName: '', legalRepAddress: '', legalRepCity: '', legalRepState: '', legalRepCountry: '', legalRepPostalCode: '', legalRepPhoneDialingCode: '', legalRepPhoneNumber: '', legalRepMobileDialingCode: '', legalRepMobileNumber: '', legalRepEmail: '',
            },
            // Addresses tab
            addresses: { billingAddress: '', billingCity: '', billingState: '', billingCountry: '', billingPostalCode: '', sameAsBilling: false, shippingAddress: '', shippingCity: '', shippingState: '', shippingCountry: '', shippingPostalCode: '' },
            billingRegions: [],
            shippingRegions: [],
            loadingBillingRegions: false,
            loadingShippingRegions: false,
            // Payment Info tab
            paymentInfo: { quickbooksVendorId: '', dunsNumber: '', federalTaxPayerId: '', awsAccountId: '', bankAccountNumber: '', bankRoutingNumber: '' },
            // Graphics tab
            graphics: { landscapeUrl: '', portraitUrl: '', logoUrl: '' },
            uploadProgress: {},
            loadingUpload: false,
            // Social tab
            social: { instagram: '', facebook: '', twitter: '', youtube: '', soundcloud: '', spotify: '', appleItunes: '', website: '', imdb: '', filmfreeway: '', stage32: '', linkedin: '' },
            // Promo Links tab
            promoLinks: [],
            promoForm: { plan: '', code: '', price: '', url: '' },
            deleteModal: { show: false, id: null },
            // Shared dropdown data
            countries: [],
            regions: [],
            creatorTypes: [],
            jobTypes: [],
            genderOptions: [],
            ethnicityOptions: [],
            // Loading flags
            loadingCountries: false,
            loadingRegions: false,
            loadingLookups: false,
            loadingSave: false,
            loadingTabSave: false,
        };
        this._toastTimer = null;
    }

    componentDidMount() {
        this.loadCountries();
        this.loadLookups();
        this.loadConfig();

        const appStorage = (window.app && window.app.storage) || {};
        const savedCreatorId = localStorage.getItem('creator_user_id');
        const loggedInUid  = (appStorage.getItem && appStorage.getItem('uid'))      || localStorage.getItem('uid');
        const loggedInType = (appStorage.getItem && appStorage.getItem('usertype')) || localStorage.getItem('usertype');

        const uid = savedCreatorId || (loggedInType === 'creator' ? loggedInUid : null);
        if (uid && uid !== this.state.createdUserId) {
            this.setState({ createdUserId: uid });
        }
        if (uid) this.fetchUser(uid);
    }

    componentDidUpdate(_, prevState) {
        if (prevState.form.country !== this.state.form.country) {
            this.state.form.country ? this.loadRegions(this.state.form.country) : this.setState({ regions: [] });
        }
        if (prevState.company.country !== this.state.company.country) {
            this.state.company.country ? this.loadCompanyRegions(this.state.company.country) : this.setState({ companyRegions: [] });
        }
        if (prevState.addresses.billingCountry !== this.state.addresses.billingCountry) {
            this.state.addresses.billingCountry ? this.loadBillingRegions(this.state.addresses.billingCountry) : this.setState({ billingRegions: [] });
        }
        if (prevState.addresses.shippingCountry !== this.state.addresses.shippingCountry) {
            this.state.addresses.shippingCountry ? this.loadShippingRegions(this.state.addresses.shippingCountry) : this.setState({ shippingRegions: [] });
        }
    }

    showToast(message, type = 'success') {
        clearTimeout(this._toastTimer);
        this.setState({ toast: { show: true, message, type } });
        this._toastTimer = setTimeout(() => this.setState({ toast: { show: false, message: '', type: '' } }), 3000);
    }

    handleTabClick(tab) {
        const appStorage = (window.app && window.app.storage) || {};
        const usertype = (appStorage.getItem && appStorage.getItem('usertype')) || localStorage.getItem('usertype');
        const isCreator = usertype === 'creator';
        if (!isCreator && RESTRICTED_TABS.includes(tab) && !this.state.createdUserId) {
            this.setState({ showUserRequiredModal: true });
            return;
        }
        this.setState({ activeTab: tab });
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    handleBack() {
        localStorage.removeItem('creator_user_id');
        localStorage.removeItem('creator_metadata_saved');
        browserHistory.goBack();
    }

    handleFieldChange(field, value) {
        this.setState(prev => ({ form: { ...prev.form, [field]: value } }));
    }

    handleCompanyChange(field, value) {
        this.setState(prev => ({ company: { ...prev.company, [field]: value } }));
    }

    handleTeamChange(field, value) {
        this.setState(prev => ({ team: { ...prev.team, [field]: value } }));
    }

    handleAddressChange(field, value) {
        this.setState(prev => {
            const next = { ...prev.addresses, [field]: value };
            if (field === 'sameAsBilling' && value) {
                next.shippingAddress  = prev.addresses.billingAddress;
                next.shippingCity     = prev.addresses.billingCity;
                next.shippingState    = prev.addresses.billingState;
                next.shippingCountry  = prev.addresses.billingCountry;
                next.shippingPostalCode = prev.addresses.billingPostalCode;
            }
            return { addresses: next };
        });
    }

    handlePaymentChange(field, value) {
        this.setState(prev => ({ paymentInfo: { ...prev.paymentInfo, [field]: value } }));
    }

    handleSocialChange(field, value) {
        this.setState(prev => ({ social: { ...prev.social, [field]: value } }));
    }

    handlePromoFormChange(field, value) {
        this.setState(prev => ({ promoForm: { ...prev.promoForm, [field]: value } }));
    }

    // ── API helpers ──────────────────────────────────────────────────────────
    loadCountries() {
        const { commonApi, appname } = getConfig();
        if (!commonApi) return;
        this.setState({ loadingCountries: true });
        axios.post(`${commonApi}/getcountries?appname=${appname}`)
            .then(res => { if (res.data && res.data.result) this.setState({ countries: res.data.result }); })
            .catch(() => {})
            .finally(() => this.setState({ loadingCountries: false }));
    }

    loadRegions(alpha3) {
        const { commonApi } = getConfig();
        if (!commonApi) return;
        this.setState({ loadingRegions: true });
        axios.post(`${commonApi}/getregions?alpha3=${alpha3}`)
            .then(res => { if (res.data && res.data.result) this.setState({ regions: res.data.result }); })
            .catch(() => {})
            .finally(() => this.setState({ loadingRegions: false }));
    }

    loadCompanyRegions(alpha3) {
        const { commonApi } = getConfig();
        if (!commonApi) return;
        this.setState({ loadingCompanyRegions: true });
        axios.post(`${commonApi}/getregions?alpha3=${alpha3}`)
            .then(res => { if (res.data && res.data.result) this.setState({ companyRegions: res.data.result }); })
            .catch(() => {})
            .finally(() => this.setState({ loadingCompanyRegions: false }));
    }

    loadBillingRegions(alpha3) {
        const { commonApi } = getConfig();
        if (!commonApi) return;
        this.setState({ loadingBillingRegions: true });
        axios.post(`${commonApi}/getregions?alpha3=${alpha3}`)
            .then(res => { if (res.data && res.data.result) this.setState({ billingRegions: res.data.result }); })
            .catch(() => {})
            .finally(() => this.setState({ loadingBillingRegions: false }));
    }

    loadShippingRegions(alpha3) {
        const { commonApi } = getConfig();
        if (!commonApi) return;
        this.setState({ loadingShippingRegions: true });
        axios.post(`${commonApi}/getregions?alpha3=${alpha3}`)
            .then(res => { if (res.data && res.data.result) this.setState({ shippingRegions: res.data.result }); })
            .catch(() => {})
            .finally(() => this.setState({ loadingShippingRegions: false }));
    }

    loadLookups() {
        const { commonApi, appname } = getConfig();
        if (!commonApi) return;
        this.setState({ loadingLookups: true });
        axios.get(`${commonApi}/lookups/creatortype,team,school/${appname}`)
            .then(res => {
                const result = res.data && res.data.result;
                if (Array.isArray(result)) {
                    const creatorData = result.find(r => r.type === 'creatortype');
                    const teamData    = result.find(r => r.type === 'team');
                    const schoolData  = result.find(r => r.type === 'school');
                    const jobTypes = [
                        ...(creatorData && creatorData.jobType ? creatorData.jobType : []),
                        ...(teamData    && teamData.jobType    ? teamData.jobType    : []),
                        ...(schoolData  && schoolData.jobType  ? schoolData.jobType  : []),
                    ];
                    this.setState({ creatorTypes: (creatorData && creatorData.values) || [], jobTypes: [...new Set(jobTypes)] });
                }
            })
            .catch(() => {})
            .finally(() => this.setState({ loadingLookups: false }));
    }

    loadConfig() {
        const { appname } = getConfig();
        const siteConfig = (window.site && window.site.config) || {};
        const cacheUrl = siteConfig.apiCacheUrl || 'https://envoi-api-cache.dev2.envoi.cloud';
        axios.get(`${cacheUrl}/configs/${appname}/dev`)
            .then(res => {
                const cfg = res.data && res.data.result && res.data.result.config;
                if (cfg) {
                    if (Array.isArray(cfg.gender))    this.setState({ genderOptions: cfg.gender });
                    if (Array.isArray(cfg.ethnicity)) this.setState({ ethnicityOptions: cfg.ethnicity });
                }
            })
            .catch(() => {});
    }

    async fetchUser(userId) {
        const { submissionLambdaUrl, appname, env } = getConfig();
        const token = getToken();
        if (!submissionLambdaUrl) return;
        try {
            const res = await axios.post(`${submissionLambdaUrl}/user?appname=${appname}&token=${token}&env=${env}&id=${userId}&userType=creator`, {}, { headers: { 'content-length': '0' } });
            const user = res.data && res.data.result && res.data.result.data && res.data.result.data[0];
            if (user) this.populateAll(user, userId);
        } catch (e) {}
    }

    populateAll(user, userId) {
        const promoLink = user.envoiId ? `${window.location.origin}/promo/${user.envoiId}` : `${window.location.origin}/promo/${userId}`;

        // Personal tab
        this.setState({
            form: {
                firstName: user.firstname || '', lastName: user.lastname || '',
                companyName: (user.companyAddress && user.companyAddress.name) || '',
                email: user.emailid || '',
                address: (user.companyAddress && user.companyAddress.address) || '',
                city: (user.companyAddress && user.companyAddress.city) || '',
                country: (user.companyAddress && user.companyAddress.country) || '',
                state: (user.companyAddress && user.companyAddress.state) || '',
                postalCode: (user.companyAddress && user.companyAddress.postalCode) || '',
                homePhoneDialingCode: (user.homePhone && user.homePhone.dialingCode) || '',
                homePhone: (user.homePhone && user.homePhone.number) || '',
                mobileDialingCode: (user.mobileNumber && user.mobileNumber.dialingCode) || '',
                mobileNumber: (user.mobileNumber && user.mobileNumber.number) || '',
                dateOfBirth: user.dateOfBirth || '', ethnicity: user.ethnicity || '',
                gender: user.gender || '', creatorType: user.creatorType || '',
                jobType: user.jobType || '', description: user.description || '',
                status: user.status || 'active', promoLink,
            },
            // Company tab
            company: {
                address: (user.companyAddress && user.companyAddress.address) || '',
                city: (user.companyAddress && user.companyAddress.city) || '',
                state: (user.companyAddress && user.companyAddress.state) || '',
                country: (user.companyAddress && user.companyAddress.country) || '',
                postalCode: (user.companyAddress && user.companyAddress.postalCode) || '',
                email: user.emailid || '',
                officePhoneDialingCode: (user.officePhone && user.officePhone.dialingCode) || '',
                officePhone: (user.officePhone && user.officePhone.number) || '',
                mobileDialingCode: (user.mobileNumber && user.mobileNumber.dialingCode) || '',
                mobileNumber: (user.mobileNumber && user.mobileNumber.number) || '',
            },
            // Team tab
            team: {
                talentAgentName: (user.team && user.team.talentAgent && user.team.talentAgent.name) || '',
                talentAgentAddress: (user.team && user.team.talentAgent && user.team.talentAgent.address) || '',
                talentAgentCity: (user.team && user.team.talentAgent && user.team.talentAgent.city) || '',
                talentAgentState: (user.team && user.team.talentAgent && user.team.talentAgent.state) || '',
                talentAgentCountry: (user.team && user.team.talentAgent && user.team.talentAgent.country) || '',
                talentAgentPostalCode: (user.team && user.team.talentAgent && user.team.talentAgent.postalCode) || '',
                talentAgentPhoneDialingCode: (user.team && user.team.talentAgent && user.team.talentAgent.phoneDialingCode) || '',
                talentAgentPhoneNumber: (user.team && user.team.talentAgent && user.team.talentAgent.phoneNumber) || '',
                talentAgentMobileDialingCode: (user.team && user.team.talentAgent && user.team.talentAgent.mobileDialingCode) || '',
                talentAgentMobileNumber: (user.team && user.team.talentAgent && user.team.talentAgent.mobileNumber) || '',
                talentAgentEmail: (user.team && user.team.talentAgent && user.team.talentAgent.email) || '',
                talentManagerName: (user.team && user.team.talentManager && user.team.talentManager.name) || '',
                talentManagerAddress: (user.team && user.team.talentManager && user.team.talentManager.address) || '',
                talentManagerCity: (user.team && user.team.talentManager && user.team.talentManager.city) || '',
                talentManagerState: (user.team && user.team.talentManager && user.team.talentManager.state) || '',
                talentManagerCountry: (user.team && user.team.talentManager && user.team.talentManager.country) || '',
                talentManagerPostalCode: (user.team && user.team.talentManager && user.team.talentManager.postalCode) || '',
                talentManagerPhoneDialingCode: (user.team && user.team.talentManager && user.team.talentManager.phoneDialingCode) || '',
                talentManagerPhoneNumber: (user.team && user.team.talentManager && user.team.talentManager.phoneNumber) || '',
                talentManagerMobileDialingCode: (user.team && user.team.talentManager && user.team.talentManager.mobileDialingCode) || '',
                talentManagerMobileNumber: (user.team && user.team.talentManager && user.team.talentManager.mobileNumber) || '',
                talentManagerEmail: (user.team && user.team.talentManager && user.team.talentManager.email) || '',
                publicistName: (user.team && user.team.publicist && user.team.publicist.name) || '',
                publicistAddress: (user.team && user.team.publicist && user.team.publicist.address) || '',
                publicistCity: (user.team && user.team.publicist && user.team.publicist.city) || '',
                publicistState: (user.team && user.team.publicist && user.team.publicist.state) || '',
                publicistCountry: (user.team && user.team.publicist && user.team.publicist.country) || '',
                publicistPostalCode: (user.team && user.team.publicist && user.team.publicist.postalCode) || '',
                publicistPhoneDialingCode: (user.team && user.team.publicist && user.team.publicist.phoneDialingCode) || '',
                publicistPhoneNumber: (user.team && user.team.publicist && user.team.publicist.phoneNumber) || '',
                publicistMobileDialingCode: (user.team && user.team.publicist && user.team.publicist.mobileDialingCode) || '',
                publicistMobileNumber: (user.team && user.team.publicist && user.team.publicist.mobileNumber) || '',
                publicistEmail: (user.team && user.team.publicist && user.team.publicist.email) || '',
                legalRepName: (user.team && user.team.legalRep && user.team.legalRep.name) || '',
                legalRepAddress: (user.team && user.team.legalRep && user.team.legalRep.address) || '',
                legalRepCity: (user.team && user.team.legalRep && user.team.legalRep.city) || '',
                legalRepState: (user.team && user.team.legalRep && user.team.legalRep.state) || '',
                legalRepCountry: (user.team && user.team.legalRep && user.team.legalRep.country) || '',
                legalRepPostalCode: (user.team && user.team.legalRep && user.team.legalRep.postalCode) || '',
                legalRepPhoneDialingCode: (user.team && user.team.legalRep && user.team.legalRep.phoneDialingCode) || '',
                legalRepPhoneNumber: (user.team && user.team.legalRep && user.team.legalRep.phoneNumber) || '',
                legalRepMobileDialingCode: (user.team && user.team.legalRep && user.team.legalRep.mobileDialingCode) || '',
                legalRepMobileNumber: (user.team && user.team.legalRep && user.team.legalRep.mobileNumber) || '',
                legalRepEmail: (user.team && user.team.legalRep && user.team.legalRep.email) || '',
            },
            // Addresses tab
            addresses: {
                billingAddress: (user.addresses && user.addresses.billing && user.addresses.billing.address) || '',
                billingCity: (user.addresses && user.addresses.billing && user.addresses.billing.city) || '',
                billingState: (user.addresses && user.addresses.billing && user.addresses.billing.state) || '',
                billingCountry: (user.addresses && user.addresses.billing && user.addresses.billing.country) || '',
                billingPostalCode: (user.addresses && user.addresses.billing && user.addresses.billing.postalCode) || '',
                sameAsBilling: (user.addresses && user.addresses.sameAsBilling) || false,
                shippingAddress: (user.addresses && user.addresses.shipping && user.addresses.shipping.address) || '',
                shippingCity: (user.addresses && user.addresses.shipping && user.addresses.shipping.city) || '',
                shippingState: (user.addresses && user.addresses.shipping && user.addresses.shipping.state) || '',
                shippingCountry: (user.addresses && user.addresses.shipping && user.addresses.shipping.country) || '',
                shippingPostalCode: (user.addresses && user.addresses.shipping && user.addresses.shipping.postalCode) || '',
            },
            // Payment Info
            paymentInfo: {
                quickbooksVendorId: (user.paymentInfo && user.paymentInfo.quickbooksVendorId) || '',
                dunsNumber: (user.paymentInfo && user.paymentInfo.dunsNumber) || '',
                federalTaxPayerId: (user.paymentInfo && user.paymentInfo.federalTaxPayerId) || '',
                awsAccountId: (user.paymentInfo && user.paymentInfo.awsAccountId) || '',
                bankAccountNumber: (user.paymentInfo && user.paymentInfo.bankAccountNumber) || '',
                bankRoutingNumber: (user.paymentInfo && user.paymentInfo.bankRoutingNumber) || '',
            },
            // Graphics
            graphics: {
                landscapeUrl: user.landscape_logo_image || user.Landscape_1920x1080 || '',
                portraitUrl: user.portrait_logo_image || user.Portrait_1000x1294 || '',
                logoUrl: user.logo || user.Logo || '',
            },
            // Social
            social: {
                instagram: (user.socialLinks && user.socialLinks.instagram) || '',
                facebook: (user.socialLinks && user.socialLinks.facebook) || '',
                twitter: (user.socialLinks && user.socialLinks.twitter) || '',
                youtube: (user.socialLinks && user.socialLinks.youtube) || '',
                soundcloud: (user.socialLinks && user.socialLinks.soundcloud) || '',
                spotify: (user.socialLinks && user.socialLinks.spotify) || '',
                appleItunes: (user.socialLinks && user.socialLinks.appleItunes) || '',
                website: (user.socialLinks && user.socialLinks.website) || '',
                imdb: (user.socialLinks && user.socialLinks.imdb) || '',
                filmfreeway: (user.socialLinks && user.socialLinks.filmfreeway) || '',
                stage32: (user.socialLinks && user.socialLinks.stage32) || '',
                linkedin: (user.socialLinks && user.socialLinks.linkedin) || '',
            },
            // Promo Links
            promoLinks: (user.promoCodes || user.promoLinks || []).map(l => ({
                id: l.id || Date.now() + Math.random(),
                plan: l.plan || '', planId: l.planId || '',
                code: l.code || '', price: l.price || '',
                url: l.url || '', createdAt: l.createdAt || new Date().toISOString(),
            })),
        });
    }

    getCountryName(code) {
        const c = this.state.countries.find(x => x.alpha3 === code || x.alpha2 === code);
        return c ? c.countryname : code;
    }

    getRegionName(val, regions) {
        const r = (regions || this.state.regions).find(x => x.regionname === val);
        return r ? r.regionname : val;
    }

    dialingCodeOptions() {
        return this.state.countries.map(c => {
            const idc = c.idc || `+${c.phone_code}`;
            return { value: idc, label: `${c.countryname} (${idc})` };
        });
    }

    // ── Generic update helper — fetches current user then patches with new fields ──
    async patchUser(extraFields) {
        const { submissionLambdaUrl, appname, env } = getConfig();
        const token = getToken();
        const uid = this.state.createdUserId;
        if (!uid || !submissionLambdaUrl) throw new Error('No user ID');

        // Fetch current to preserve existing data
        let current = {};
        try {
            const res = await axios.post(`${submissionLambdaUrl}/user?appname=${appname}&token=${token}&env=${env}&id=${uid}&userType=creator`, {}, { headers: { 'content-length': '0' } });
            current = (res.data && res.data.result && res.data.result.data && res.data.result.data[0]) || {};
        } catch (e) {}

        const payload = {
            status: current.status || 'active',
            firstname: current.firstname || '',
            lastname: current.lastname || '',
            emailid: current.emailid || '',
            usertype: 'creator',
            category: 'content-creator',
            appname,
            creatorType: current.creatorType || 'content-creator',
            ...extraFields,
        };
        // Preserve existing fields not in extraFields
        const preserve = ['companyAddress', 'homePhone', 'officePhone', 'mobileNumber', 'dateOfBirth', 'ethnicity', 'gender', 'jobType', 'description', 'team', 'addresses', 'paymentInfo', 'socialLinks', 'promoCodes'];
        preserve.forEach(f => { if (current[f] && !payload[f]) payload[f] = current[f]; });

        await axios.post(`${submissionLambdaUrl}/manageUser?appname=${appname}&env=${env}&token=${token}&_id=${uid}`, payload, { headers: { 'content-type': 'application/json' } });
    }

    // ── Personal save ────────────────────────────────────────────────────────
    async handleSave() {
        const { form, createdUserId } = this.state;
        if (!form.firstName.trim()) { this.showToast('First Name is required', 'error'); return; }
        if (!form.lastName.trim())  { this.showToast('Last Name is required', 'error');  return; }
        const { screeningApi, appname, env } = getConfig();
        const token = getToken();
        this.setState({ loadingSave: true });
        const body = {
            status: form.status || 'active', firstname: form.firstName.trim(), lastname: form.lastName.trim(),
            emailid: form.email.trim(), usertype: 'creator', category: 'content-creator', appname,
            creatorType: form.creatorType || 'content-creator',
            companyAddress: { name: form.companyName || `${form.firstName} ${form.lastName}`, address: form.address, city: form.city, country: form.country, countryName: this.getCountryName(form.country), state: form.state, stateName: this.getRegionName(form.state), postalCode: form.postalCode },
            ...(form.homePhone   ? { homePhone:    { dialingCode: form.homePhoneDialingCode,  number: form.homePhone   } } : {}),
            ...(form.mobileNumber ? { mobileNumber: { dialingCode: form.mobileDialingCode,     number: form.mobileNumber } } : {}),
            dateOfBirth: form.dateOfBirth, ethnicity: form.ethnicity, gender: form.gender,
            jobType: form.jobType, description: form.description,
        };
        try {
            let url = `${screeningApi}/manageUser?appname=${appname}&env=${env}&token=${token}`;
            if (createdUserId) url += `&_id=${createdUserId}`;
            const res = await axios.post(url, body, { headers: { 'content-type': 'application/json' } });
            const data = res.data || {};
            if (data.message && data.message.toLowerCase().includes('email already exist')) { this.showToast('This email is already registered.', 'error'); return; }
            const newId = createdUserId || (data.result && data.result[0] && data.result[0]._id) || (data.result && data.result._id) || data._id;
            if (newId) {
                localStorage.setItem('creator_user_id', newId);
                localStorage.setItem('creator_metadata_saved', 'true');
                this.setState({ createdUserId: newId });
                this.fetchUser(newId);
            }
            if (createdUserId) {
                this.showToast('Updated successfully!');
            } else {
                this.setState({ showSuccessModal: true, successEmail: form.email.trim() });
            }
        } catch (err) {
            this.showToast('Failed to save. Please try again.', 'error');
        } finally {
            this.setState({ loadingSave: false });
        }
    }

    // ── Company save ─────────────────────────────────────────────────────────
    async handleCompanySave() {
        const { company, createdUserId } = this.state;
        if (!createdUserId) { this.showToast('Save Personal Information first.', 'error'); return; }
        this.setState({ loadingTabSave: true });
        try {
            await this.patchUser({
                companyAddress: { name: '', address: company.address, city: company.city, country: company.country, countryName: this.getCountryName(company.country), state: company.state, stateName: this.getRegionName(company.state, this.state.companyRegions), postalCode: company.postalCode },
                emailid: company.email,
                ...(company.officePhone ? { officePhone: { dialingCode: company.officePhoneDialingCode, number: company.officePhone } } : {}),
                ...(company.mobileNumber ? { mobileNumber: { dialingCode: company.mobileDialingCode, number: company.mobileNumber } } : {}),
            });
            this.showToast('Company information updated!');
        } catch (e) { this.showToast('Failed to save company info.', 'error'); }
        finally { this.setState({ loadingTabSave: false }); }
    }

    // ── Team save ─────────────────────────────────────────────────────────────
    async handleTeamSave() {
        const { team, createdUserId } = this.state;
        if (!createdUserId) { this.showToast('Save Personal Information first.', 'error'); return; }
        this.setState({ loadingTabSave: true });
        const mkPerson = (prefix) => ({
            name: team[`${prefix}Name`], address: team[`${prefix}Address`], city: team[`${prefix}City`],
            state: team[`${prefix}State`], country: team[`${prefix}Country`],
            postalCode: team[`${prefix}PostalCode`],
            phoneDialingCode: team[`${prefix}PhoneDialingCode`], phoneNumber: team[`${prefix}PhoneNumber`],
            mobileDialingCode: team[`${prefix}MobileDialingCode`], mobileNumber: team[`${prefix}MobileNumber`],
            email: team[`${prefix}Email`],
        });
        try {
            await this.patchUser({ team: { talentAgent: mkPerson('talentAgent'), talentManager: mkPerson('talentManager'), publicist: mkPerson('publicist'), legalRep: mkPerson('legalRep') } });
            this.showToast('Team information updated!');
        } catch (e) { this.showToast('Failed to save team info.', 'error'); }
        finally { this.setState({ loadingTabSave: false }); }
    }

    // ── Addresses save ────────────────────────────────────────────────────────
    async handleAddressesSave() {
        const { addresses, createdUserId } = this.state;
        if (!createdUserId) { this.showToast('Save Personal Information first.', 'error'); return; }
        this.setState({ loadingTabSave: true });
        try {
            await this.patchUser({
                addresses: {
                    billing: { address: addresses.billingAddress, city: addresses.billingCity, state: addresses.billingState, country: addresses.billingCountry, countryName: this.getCountryName(addresses.billingCountry), stateName: this.getRegionName(addresses.billingState, this.state.billingRegions), postalCode: addresses.billingPostalCode },
                    shipping: addresses.sameAsBilling ? null : { address: addresses.shippingAddress, city: addresses.shippingCity, state: addresses.shippingState, country: addresses.shippingCountry, countryName: this.getCountryName(addresses.shippingCountry), stateName: this.getRegionName(addresses.shippingState, this.state.shippingRegions), postalCode: addresses.shippingPostalCode },
                    sameAsBilling: addresses.sameAsBilling,
                },
            });
            this.showToast('Addresses updated!');
        } catch (e) { this.showToast('Failed to save addresses.', 'error'); }
        finally { this.setState({ loadingTabSave: false }); }
    }

    // ── Payment save ──────────────────────────────────────────────────────────
    async handlePaymentSave() {
        const { paymentInfo, createdUserId } = this.state;
        if (!createdUserId) { this.showToast('Save Personal Information first.', 'error'); return; }
        this.setState({ loadingTabSave: true });
        try {
            await this.patchUser({ paymentInfo: { ...paymentInfo, lastUpdated: new Date().toISOString() } });
            this.showToast('Payment information updated!');
        } catch (e) { this.showToast('Failed to save payment info.', 'error'); }
        finally { this.setState({ loadingTabSave: false }); }
    }

    // ── Social save ───────────────────────────────────────────────────────────
    async handleSocialSave() {
        const { social, createdUserId } = this.state;
        if (!createdUserId) { this.showToast('Save Personal Information first.', 'error'); return; }
        this.setState({ loadingTabSave: true });
        try {
            await this.patchUser({ socialLinks: social });
            this.showToast('Social links updated!');
        } catch (e) { this.showToast('Failed to save social links.', 'error'); }
        finally { this.setState({ loadingTabSave: false }); }
    }

    // ── Promo Links ───────────────────────────────────────────────────────────
    addPromoLink() {
        const { promoForm, promoLinks } = this.state;
        if (!promoForm.plan || !promoForm.code || !promoForm.price || !promoForm.url) { this.showToast('Please fill in all fields.', 'error'); return; }
        if (promoLinks.some(l => l.code.toLowerCase() === promoForm.code.toLowerCase())) { this.showToast('Promo code already exists.', 'error'); return; }
        const newLink = { id: Date.now(), plan: promoForm.plan, planId: `PLAN_${promoForm.plan.toUpperCase().replace(/\s+/g, '_')}`, code: promoForm.code, price: promoForm.price, url: promoForm.url, createdAt: new Date().toISOString() };
        this.setState(prev => ({ promoLinks: [...prev.promoLinks, newLink], promoForm: { plan: '', code: '', price: '', url: '' } }));
    }

    async handlePromoSave() {
        const { promoLinks, createdUserId } = this.state;
        if (!createdUserId) { this.showToast('Save Personal Information first.', 'error'); return; }
        this.setState({ loadingTabSave: true });
        try {
            await this.patchUser({ promoCodes: promoLinks });
            this.showToast('Promo links saved!');
        } catch (e) { this.showToast('Failed to save promo links.', 'error'); }
        finally { this.setState({ loadingTabSave: false }); }
    }

    removePromoLink(id) { this.setState({ deleteModal: { show: true, id } }); }

    confirmRemovePromoLink() {
        const { deleteModal, promoLinks } = this.state;
        this.setState({ promoLinks: promoLinks.filter(l => l.id !== deleteModal.id), deleteModal: { show: false, id: null } });
        this.showToast('Promo link removed.');
    }

    // ── Graphics upload ───────────────────────────────────────────────────────
    async handleGraphicsUpload(file, fieldKey, fieldName) {
        const { createdUserId } = this.state;
        if (!createdUserId) { this.showToast('Save Personal Information first.', 'error'); return; }
        if (!file || !file.type.startsWith('image/')) { this.showToast('Please upload a valid image file.', 'error'); return; }
        const { submissionLambdaUrl, appname, env } = getConfig();
        const token = getToken();
        const timestamp = Date.now();
        const ext = file.name.split('.').pop();
        const sourcePath = `${appname}/submission/creator/${createdUserId}/${fieldKey}_${timestamp}.${ext}`;
        this.setState({ loadingUpload: true, uploadProgress: { ...this.state.uploadProgress, [fieldKey]: 0 } });
        try {
            const urlRes = await fetch(`${submissionLambdaUrl}/uploadURL?appname=${appname}&env=${env}&token=${token}`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ source_bucket: 'envoi-kj-resources', sourcepath: sourcePath }) });
            const urlData = await urlRes.json();
            const signedUrl = urlData && urlData.result;
            if (!signedUrl) throw new Error('No signed URL');
            this.setState({ uploadProgress: { ...this.state.uploadProgress, [fieldKey]: 20 } });
            await new Promise((resolve, reject) => {
                const xhr = new XMLHttpRequest();
                xhr.upload.addEventListener('progress', e => { if (e.lengthComputable) this.setState({ uploadProgress: { ...this.state.uploadProgress, [fieldKey]: Math.round(20 + e.loaded / e.total * 60) } }); });
                xhr.addEventListener('load', () => xhr.status < 300 ? resolve() : reject());
                xhr.addEventListener('error', reject);
                xhr.open('PUT', signedUrl);
                xhr.setRequestHeader('Content-Type', file.type);
                xhr.send(file);
            });
            const finalUrl = `https://envoi-common-resources.imgix.net/${sourcePath}`;
            await this.patchUser({ [fieldName]: finalUrl });
            this.setState(prev => ({ graphics: { ...prev.graphics, [`${fieldKey}Url`]: finalUrl }, uploadProgress: { ...prev.uploadProgress, [fieldKey]: null } }));
            this.showToast('Image uploaded successfully!');
        } catch (e) {
            this.showToast('Upload failed.', 'error');
            this.setState({ uploadProgress: { ...this.state.uploadProgress, [fieldKey]: null } });
        } finally {
            this.setState({ loadingUpload: false });
        }
    }

    // ── Renderers ─────────────────────────────────────────────────────────────

    renderPersonalTab() {
        const { form, countries, regions, creatorTypes, jobTypes, genderOptions, ethnicityOptions, loadingCountries, loadingRegions, loadingSave } = this.state;
        const dialCodes = this.dialingCodeOptions();
        return (
            <>
                <h2 style={S.sectionTitle}>Personal Information</h2>
                <div style={S.row} className="cr-row">
                    <div style={S.field}><label style={S.label}>First Name<span style={S.required}>*</span></label><input style={S.input} type="text" placeholder="Enter first name" value={form.firstName} onChange={e => this.handleFieldChange('firstName', e.target.value)} disabled={loadingSave} /></div>
                    <div style={S.field}><label style={S.label}>Last Name<span style={S.required}>*</span></label><input style={S.input} type="text" placeholder="Enter last name" value={form.lastName} onChange={e => this.handleFieldChange('lastName', e.target.value)} disabled={loadingSave} /></div>
                    <div style={S.field}><label style={S.label}>Company Name</label><input style={S.input} type="text" placeholder="Enter company name" value={form.companyName} onChange={e => this.handleFieldChange('companyName', e.target.value)} disabled={loadingSave} /></div>
                </div>
                <div style={S.row} className="cr-row">
                    <div style={S.field}><label style={S.label}>Email</label><input style={S.input} type="email" placeholder="Enter email" value={form.email} onChange={e => this.handleFieldChange('email', e.target.value)} disabled={loadingSave} /></div>
                    <div style={S.field}><label style={S.label}>Address</label><input style={S.input} type="text" placeholder="Street address" value={form.address} onChange={e => this.handleFieldChange('address', e.target.value)} disabled={loadingSave} /></div>
                    <div style={S.field}><label style={S.label}>City</label><input style={S.input} type="text" placeholder="City" value={form.city} onChange={e => this.handleFieldChange('city', e.target.value)} disabled={loadingSave} /></div>
                </div>
                <div style={S.row} className="cr-row">
                    <div style={S.field}><label style={S.label}>Country</label><select style={S.select} value={form.country} onChange={e => this.handleFieldChange('country', e.target.value)} disabled={loadingCountries || loadingSave}><option value="">Select Country</option>{countries.map(c => <option key={c.alpha3 || c._id} value={c.alpha3 || c.code}>{c.countryname}</option>)}</select></div>
                    <div style={S.field}><label style={S.label}>State/Region</label><select style={S.select} value={form.state} onChange={e => this.handleFieldChange('state', e.target.value)} disabled={!form.country || loadingRegions || loadingSave}><option value="">Select State/Region</option>{regions.map(r => <option key={r._id || r.regioncode} value={r.regionname}>{r.regionname}</option>)}</select></div>
                    <div style={S.field}><label style={S.label}>Postal Code</label><input style={S.input} type="text" placeholder="Postal code" value={form.postalCode} onChange={e => this.handleFieldChange('postalCode', e.target.value)} disabled={loadingSave} /></div>
                </div>
                <div style={S.row} className="cr-row">
                    <div style={S.field}><label style={S.label}>Home Phone</label><div style={S.phoneRow} className="cr-phone-row"><select style={S.codeSelect} className="cr-code-select" value={form.homePhoneDialingCode} onChange={e => this.handleFieldChange('homePhoneDialingCode', e.target.value)} disabled={loadingSave}><option value="">Code</option>{dialCodes.map((o, i) => <option key={i} value={o.value}>{o.label}</option>)}</select><input style={{ ...S.input, flex: 1 }} type="tel" placeholder="Home phone" value={form.homePhone} onChange={e => this.handleFieldChange('homePhone', e.target.value)} disabled={loadingSave} /></div></div>
                    <div style={S.field}><label style={S.label}>Mobile Number</label><div style={S.phoneRow} className="cr-phone-row"><select style={S.codeSelect} className="cr-code-select" value={form.mobileDialingCode} onChange={e => this.handleFieldChange('mobileDialingCode', e.target.value)} disabled={loadingSave}><option value="">Code</option>{dialCodes.map((o, i) => <option key={i} value={o.value}>{o.label}</option>)}</select><input style={{ ...S.input, flex: 1 }} type="tel" placeholder="Mobile number" value={form.mobileNumber} onChange={e => this.handleFieldChange('mobileNumber', e.target.value)} disabled={loadingSave} /></div></div>
                    <div style={S.field}><label style={S.label}>Date of Birth</label><input style={S.input} type="date" value={form.dateOfBirth} onChange={e => this.handleFieldChange('dateOfBirth', e.target.value)} disabled={loadingSave} /></div>
                </div>
                <div style={S.row} className="cr-row">
                    <div style={S.field}><label style={S.label}>Ethnicity</label><select style={S.select} value={form.ethnicity} onChange={e => this.handleFieldChange('ethnicity', e.target.value)} disabled={loadingSave}><option value="">Select Ethnicity</option>{ethnicityOptions.map((v, i) => <option key={i} value={v}>{v}</option>)}</select></div>
                    <div style={S.field}><label style={S.label}>Gender</label><select style={S.select} value={form.gender} onChange={e => this.handleFieldChange('gender', e.target.value)} disabled={loadingSave}><option value="">Select Gender</option>{genderOptions.map((v, i) => <option key={i} value={v}>{v}</option>)}</select></div>
                    <div style={S.field}><label style={S.label}>Creator Type</label><select style={S.select} value={form.creatorType} onChange={e => this.handleFieldChange('creatorType', e.target.value)} disabled={loadingSave}><option value="">Select Creator Type</option>{creatorTypes.map((v, i) => <option key={i} value={v}>{v}</option>)}</select></div>
                </div>
                <div style={S.row} className="cr-row">
                    <div style={S.field}><label style={S.label}>Job Type</label><select style={S.select} value={form.jobType} onChange={e => this.handleFieldChange('jobType', e.target.value)} disabled={loadingSave}><option value="">Select Job Type</option>{jobTypes.map((v, i) => <option key={i} value={v}>{v}</option>)}</select></div>
                    <div style={S.field}><label style={S.label}>Promo Link</label><input style={{ ...S.input, background: 'rgba(255,255,255,0.03)', cursor: 'not-allowed' }} type="text" readOnly value={form.promoLink} placeholder="Generated after save" /></div>
                    <div style={S.field}><label style={S.label}>Status</label><select style={S.select} value={form.status} onChange={e => this.handleFieldChange('status', e.target.value)} disabled={loadingSave}><option value="active">Active</option><option value="inactive">Inactive</option><option value="archive">Archive</option></select></div>
                </div>
                <div style={S.rowFull}><div style={S.field}><label style={S.label}>Description</label><textarea style={S.textarea} placeholder="Enter description..." value={form.description} onChange={e => this.handleFieldChange('description', e.target.value)} disabled={loadingSave} /></div></div>
                <div style={S.saveRow}><button style={S.saveBtn} onClick={() => this.handleSave()} disabled={loadingSave}>{loadingSave ? 'Saving...' : (this.state.createdUserId ? 'Update' : 'Create')}</button></div>
            </>
        );
    }

    renderCompanyTab() {
        const { company, companyRegions, countries, loadingCountries, loadingCompanyRegions, loadingTabSave } = this.state;
        const dialCodes = this.dialingCodeOptions();
        return (
            <>
                <h2 style={S.sectionTitle}>Company Information</h2>
                <div style={S.row} className="cr-row">
                    <div style={S.field}><label style={S.label}>Address</label><input style={S.input} type="text" placeholder="Street address" value={company.address} onChange={e => this.handleCompanyChange('address', e.target.value)} disabled={loadingTabSave} /></div>
                    <div style={S.field}><label style={S.label}>City</label><input style={S.input} type="text" placeholder="City" value={company.city} onChange={e => this.handleCompanyChange('city', e.target.value)} disabled={loadingTabSave} /></div>
                    <div style={S.field}><label style={S.label}>State/Region</label><select style={S.select} value={company.state} onChange={e => this.handleCompanyChange('state', e.target.value)} disabled={!company.country || loadingCompanyRegions || loadingTabSave}><option value="">Select State/Region</option>{companyRegions.map(r => <option key={r._id || r.regioncode} value={r.regionname}>{r.regionname}</option>)}</select></div>
                </div>
                <div style={S.row} className="cr-row">
                    <div style={S.field}><label style={S.label}>Country</label><select style={S.select} value={company.country} onChange={e => this.handleCompanyChange('country', e.target.value)} disabled={loadingCountries || loadingTabSave}><option value="">Select Country</option>{countries.map(c => <option key={c.alpha3 || c._id} value={c.alpha3 || c.code}>{c.countryname}</option>)}</select></div>
                    <div style={S.field}><label style={S.label}>Postal Code</label><input style={S.input} type="text" placeholder="Postal code" value={company.postalCode} onChange={e => this.handleCompanyChange('postalCode', e.target.value)} disabled={loadingTabSave} /></div>
                    <div style={S.field}><label style={S.label}>Email<span style={S.required}>*</span></label><input style={S.input} type="email" placeholder="Company email" value={company.email} onChange={e => this.handleCompanyChange('email', e.target.value)} disabled={loadingTabSave} /></div>
                </div>
                <div style={S.row} className="cr-row">
                    <div style={S.field}><label style={S.label}>Office Phone</label><div style={S.phoneRow} className="cr-phone-row"><select style={S.codeSelect} className="cr-code-select" value={company.officePhoneDialingCode} onChange={e => this.handleCompanyChange('officePhoneDialingCode', e.target.value)} disabled={loadingTabSave}><option value="">Code</option>{dialCodes.map((o, i) => <option key={i} value={o.value}>{o.label}</option>)}</select><input style={{ ...S.input, flex: 1 }} type="tel" placeholder="Office phone" value={company.officePhone} onChange={e => this.handleCompanyChange('officePhone', e.target.value)} disabled={loadingTabSave} /></div></div>
                    <div style={S.field}><label style={S.label}>Mobile Number</label><div style={S.phoneRow} className="cr-phone-row"><select style={S.codeSelect} className="cr-code-select" value={company.mobileDialingCode} onChange={e => this.handleCompanyChange('mobileDialingCode', e.target.value)} disabled={loadingTabSave}><option value="">Code</option>{dialCodes.map((o, i) => <option key={i} value={o.value}>{o.label}</option>)}</select><input style={{ ...S.input, flex: 1 }} type="tel" placeholder="Mobile number" value={company.mobileNumber} onChange={e => this.handleCompanyChange('mobileNumber', e.target.value)} disabled={loadingTabSave} /></div></div>
                </div>
                <div style={S.saveRow}><button style={S.saveBtn} onClick={() => this.handleCompanySave()} disabled={loadingTabSave}>{loadingTabSave ? 'Saving...' : 'Update Company Info'}</button></div>
            </>
        );
    }

    renderTeamSection(title, prefix) {
        const { team, countries, loadingTabSave } = this.state;
        const dialCodes = this.dialingCodeOptions();
        return (
            <div key={prefix}>
                <p style={S.subTitle}>{title}</p>
                <div style={S.row} className="cr-row">
                    <div style={S.field}><label style={S.label}>Name</label><input style={S.input} type="text" placeholder="Full name" value={team[`${prefix}Name`]} onChange={e => this.handleTeamChange(`${prefix}Name`, e.target.value)} disabled={loadingTabSave} /></div>
                    <div style={S.field}><label style={S.label}>Email</label><input style={S.input} type="email" placeholder="Email" value={team[`${prefix}Email`]} onChange={e => this.handleTeamChange(`${prefix}Email`, e.target.value)} disabled={loadingTabSave} /></div>
                    <div style={S.field}><label style={S.label}>Address</label><input style={S.input} type="text" placeholder="Street address" value={team[`${prefix}Address`]} onChange={e => this.handleTeamChange(`${prefix}Address`, e.target.value)} disabled={loadingTabSave} /></div>
                </div>
                <div style={S.row} className="cr-row">
                    <div style={S.field}><label style={S.label}>City</label><input style={S.input} type="text" placeholder="City" value={team[`${prefix}City`]} onChange={e => this.handleTeamChange(`${prefix}City`, e.target.value)} disabled={loadingTabSave} /></div>
                    <div style={S.field}><label style={S.label}>Country</label><select style={S.select} value={team[`${prefix}Country`]} onChange={e => this.handleTeamChange(`${prefix}Country`, e.target.value)} disabled={loadingTabSave}><option value="">Select Country</option>{countries.map(c => <option key={c.alpha3 || c._id} value={c.alpha3 || c.code}>{c.countryname}</option>)}</select></div>
                    <div style={S.field}><label style={S.label}>Postal Code</label><input style={S.input} type="text" placeholder="Postal code" value={team[`${prefix}PostalCode`]} onChange={e => this.handleTeamChange(`${prefix}PostalCode`, e.target.value)} disabled={loadingTabSave} /></div>
                </div>
                <div style={S.row} className="cr-row">
                    <div style={S.field}><label style={S.label}>Phone</label><div style={S.phoneRow} className="cr-phone-row"><select style={S.codeSelect} className="cr-code-select" value={team[`${prefix}PhoneDialingCode`]} onChange={e => this.handleTeamChange(`${prefix}PhoneDialingCode`, e.target.value)} disabled={loadingTabSave}><option value="">Code</option>{dialCodes.map((o, i) => <option key={i} value={o.value}>{o.label}</option>)}</select><input style={{ ...S.input, flex: 1 }} type="tel" placeholder="Phone number" value={team[`${prefix}PhoneNumber`]} onChange={e => this.handleTeamChange(`${prefix}PhoneNumber`, e.target.value)} disabled={loadingTabSave} /></div></div>
                    <div style={S.field}><label style={S.label}>Mobile</label><div style={S.phoneRow} className="cr-phone-row"><select style={S.codeSelect} className="cr-code-select" value={team[`${prefix}MobileDialingCode`]} onChange={e => this.handleTeamChange(`${prefix}MobileDialingCode`, e.target.value)} disabled={loadingTabSave}><option value="">Code</option>{dialCodes.map((o, i) => <option key={i} value={o.value}>{o.label}</option>)}</select><input style={{ ...S.input, flex: 1 }} type="tel" placeholder="Mobile number" value={team[`${prefix}MobileNumber`]} onChange={e => this.handleTeamChange(`${prefix}MobileNumber`, e.target.value)} disabled={loadingTabSave} /></div></div>
                </div>
            </div>
        );
    }

    renderTeamTab() {
        const { loadingTabSave } = this.state;
        return (
            <>
                <h2 style={S.sectionTitle}>Team Information</h2>
                {this.renderTeamSection('Talent Agent', 'talentAgent')}
                <hr style={S.divider} />
                {this.renderTeamSection('Talent Manager', 'talentManager')}
                <hr style={S.divider} />
                {this.renderTeamSection('Publicist', 'publicist')}
                <hr style={S.divider} />
                {this.renderTeamSection('Legal Representative', 'legalRep')}
                <div style={S.saveRow}><button style={S.saveBtn} onClick={() => this.handleTeamSave()} disabled={loadingTabSave}>{loadingTabSave ? 'Saving...' : 'Update Team Info'}</button></div>
            </>
        );
    }

    renderAddressesTab() {
        const { addresses, countries, billingRegions, shippingRegions, loadingBillingRegions, loadingShippingRegions, loadingCountries, loadingTabSave } = this.state;
        return (
            <>
                <h2 style={S.sectionTitle}>Addresses</h2>
                <p style={S.subTitle}>Billing Address</p>
                <div style={S.row} className="cr-row">
                    <div style={S.field}><label style={S.label}>Address</label><input style={S.input} type="text" placeholder="Street address" value={addresses.billingAddress} onChange={e => this.handleAddressChange('billingAddress', e.target.value)} disabled={loadingTabSave} /></div>
                    <div style={S.field}><label style={S.label}>City</label><input style={S.input} type="text" placeholder="City" value={addresses.billingCity} onChange={e => this.handleAddressChange('billingCity', e.target.value)} disabled={loadingTabSave} /></div>
                    <div style={S.field}><label style={S.label}>Country</label><select style={S.select} value={addresses.billingCountry} onChange={e => this.handleAddressChange('billingCountry', e.target.value)} disabled={loadingCountries || loadingTabSave}><option value="">Select Country</option>{countries.map(c => <option key={c.alpha3 || c._id} value={c.alpha3 || c.code}>{c.countryname}</option>)}</select></div>
                </div>
                <div style={S.row} className="cr-row">
                    <div style={S.field}><label style={S.label}>State/Region</label><select style={S.select} value={addresses.billingState} onChange={e => this.handleAddressChange('billingState', e.target.value)} disabled={!addresses.billingCountry || loadingBillingRegions || loadingTabSave}><option value="">Select State/Region</option>{billingRegions.map(r => <option key={r._id || r.regioncode} value={r.regionname}>{r.regionname}</option>)}</select></div>
                    <div style={S.field}><label style={S.label}>Postal Code</label><input style={S.input} type="text" placeholder="Postal code" value={addresses.billingPostalCode} onChange={e => this.handleAddressChange('billingPostalCode', e.target.value)} disabled={loadingTabSave} /></div>
                </div>
                <hr style={S.divider} />
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '20px' }}>
                    <input type="checkbox" id="sameAsBilling" checked={addresses.sameAsBilling} onChange={e => this.handleAddressChange('sameAsBilling', e.target.checked)} style={{ width: '16px', height: '16px', cursor: 'pointer' }} />
                    <label htmlFor="sameAsBilling" style={{ ...S.label, cursor: 'pointer', fontSize: '14px', color: '#ffffff' }}>Shipping address same as billing</label>
                </div>
                {!addresses.sameAsBilling && (<>
                    <p style={S.subTitle}>Shipping Address</p>
                    <div style={S.row} className="cr-row">
                        <div style={S.field}><label style={S.label}>Address</label><input style={S.input} type="text" placeholder="Street address" value={addresses.shippingAddress} onChange={e => this.handleAddressChange('shippingAddress', e.target.value)} disabled={loadingTabSave} /></div>
                        <div style={S.field}><label style={S.label}>City</label><input style={S.input} type="text" placeholder="City" value={addresses.shippingCity} onChange={e => this.handleAddressChange('shippingCity', e.target.value)} disabled={loadingTabSave} /></div>
                        <div style={S.field}><label style={S.label}>Country</label><select style={S.select} value={addresses.shippingCountry} onChange={e => this.handleAddressChange('shippingCountry', e.target.value)} disabled={loadingCountries || loadingTabSave}><option value="">Select Country</option>{countries.map(c => <option key={c.alpha3 || c._id} value={c.alpha3 || c.code}>{c.countryname}</option>)}</select></div>
                    </div>
                    <div style={S.row} className="cr-row">
                        <div style={S.field}><label style={S.label}>State/Region</label><select style={S.select} value={addresses.shippingState} onChange={e => this.handleAddressChange('shippingState', e.target.value)} disabled={!addresses.shippingCountry || loadingShippingRegions || loadingTabSave}><option value="">Select State/Region</option>{shippingRegions.map(r => <option key={r._id || r.regioncode} value={r.regionname}>{r.regionname}</option>)}</select></div>
                        <div style={S.field}><label style={S.label}>Postal Code</label><input style={S.input} type="text" placeholder="Postal code" value={addresses.shippingPostalCode} onChange={e => this.handleAddressChange('shippingPostalCode', e.target.value)} disabled={loadingTabSave} /></div>
                    </div>
                </>)}
                <div style={S.saveRow}><button style={S.saveBtn} onClick={() => this.handleAddressesSave()} disabled={loadingTabSave}>{loadingTabSave ? 'Saving...' : 'Update Addresses'}</button></div>
            </>
        );
    }

    renderPaymentInfoTab() {
        const { paymentInfo, loadingTabSave } = this.state;
        const fields = [
            { key: 'quickbooksVendorId', label: 'Quickbooks Vendor ID', placeholder: 'Quickbooks Vendor ID' },
            { key: 'dunsNumber', label: 'DUNS Number', placeholder: 'DUNS Number' },
            { key: 'federalTaxPayerId', label: 'Federal Tax Payer ID', placeholder: 'Federal Tax Payer ID' },
            { key: 'awsAccountId', label: 'AWS Account ID', placeholder: 'AWS Account ID' },
            { key: 'bankAccountNumber', label: 'Bank Account Number', placeholder: 'Bank Account Number' },
            { key: 'bankRoutingNumber', label: 'Bank Routing Number', placeholder: 'Bank Routing Number' },
        ];
        return (
            <>
                <h2 style={S.sectionTitle}>Payment Information</h2>
                <div style={S.row} className="cr-row">
                    {fields.map(f => (
                        <div style={S.field} key={f.key}>
                            <label style={S.label}>{f.label}</label>
                            <input style={S.input} type="text" placeholder={f.placeholder} value={paymentInfo[f.key]} onChange={e => this.handlePaymentChange(f.key, e.target.value)} disabled={loadingTabSave} />
                        </div>
                    ))}
                </div>
                <div style={S.saveRow}><button style={S.saveBtn} onClick={() => this.handlePaymentSave()} disabled={loadingTabSave}>{loadingTabSave ? 'Saving...' : 'Update Payment Info'}</button></div>
            </>
        );
    }

    renderGraphicsTab() {
        const { graphics, uploadProgress, loadingUpload } = this.state;
        const graphicItems = [
            { key: 'landscape', fieldName: 'landscape_logo_image', label: 'Landscape Image', desc: '1920 × 1080 JPG/PNG', url: graphics.landscapeUrl },
            { key: 'portrait',  fieldName: 'portrait_logo_image',  label: 'Portrait Image',  desc: '1000 × 1294 JPG/PNG', url: graphics.portraitUrl },
            { key: 'logo',      fieldName: 'logo',                  label: 'Logo',             desc: 'PNG (square)',        url: graphics.logoUrl },
        ];
        return (
            <>
                <h2 style={S.sectionTitle}>Graphics</h2>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px' }} className="cr-graphics-grid">
                    {graphicItems.map(item => (
                        <div key={item.key}>
                            <p style={{ ...S.subTitle, marginTop: 0 }}>{item.label}</p>
                            <p style={{ ...S.label, marginBottom: '12px' }}>{item.desc}</p>
                            {item.url ? (
                                <div style={{ marginBottom: '12px', position: 'relative' }}>
                                    <img src={item.url} alt={item.label} style={{ width: '100%', height: '160px', objectFit: 'cover', borderRadius: '8px', border: '1px solid rgba(255,255,255,0.1)' }} />
                                </div>
                            ) : null}
                            {uploadProgress[item.key] != null ? (
                                <div style={{ height: '6px', background: 'rgba(255,255,255,0.1)', borderRadius: '3px', overflow: 'hidden', marginBottom: '8px' }}>
                                    <div style={{ height: '100%', width: `${uploadProgress[item.key]}%`, background: 'var(--highlight, #e9c548)', transition: 'width 0.3s' }} />
                                </div>
                            ) : null}
                            <label style={{ ...S.uploadBox, cursor: loadingUpload ? 'not-allowed' : 'pointer' }}>
                                <span style={{ fontSize: '24px', opacity: 0.5 }}>⬆</span>
                                <span style={{ fontSize: '13px', color: '#aaaaaa' }}>Click to upload</span>
                                <input type="file" accept="image/*" style={{ display: 'none' }} disabled={loadingUpload} onChange={e => { if (e.target.files[0]) this.handleGraphicsUpload(e.target.files[0], item.key, item.fieldName); e.target.value = ''; }} />
                            </label>
                        </div>
                    ))}
                </div>
            </>
        );
    }

    renderSocialTab() {
        const { social, loadingTabSave } = this.state;
        const platforms = [
            { key: 'instagram', label: 'Instagram', placeholder: 'https://instagram.com/username' },
            { key: 'facebook', label: 'Facebook', placeholder: 'https://facebook.com/pagename' },
            { key: 'twitter', label: 'Twitter / X', placeholder: 'https://twitter.com/username' },
            { key: 'youtube', label: 'YouTube', placeholder: 'https://youtube.com/@channel' },
            { key: 'soundcloud', label: 'SoundCloud', placeholder: 'https://soundcloud.com/username' },
            { key: 'spotify', label: 'Spotify', placeholder: 'https://open.spotify.com/artist/id' },
            { key: 'appleItunes', label: 'Apple iTunes', placeholder: 'https://music.apple.com/artist/id' },
            { key: 'website', label: 'Website', placeholder: 'https://yourwebsite.com' },
            { key: 'imdb', label: 'IMDB', placeholder: 'https://www.imdb.com/name/nmxxxxxxx' },
            { key: 'filmfreeway', label: 'Film Freeway', placeholder: 'https://filmfreeway.com/username' },
            { key: 'stage32', label: 'Stage 32', placeholder: 'https://www.stage32.com/username' },
            { key: 'linkedin', label: 'LinkedIn', placeholder: 'https://linkedin.com/in/username' },
        ];
        return (
            <>
                <h2 style={S.sectionTitle}>Social Media Links</h2>
                <div style={S.row} className="cr-row">
                    {platforms.map(p => (
                        <div style={S.field} key={p.key}>
                            <label style={S.label}>{p.label}</label>
                            <input style={S.input} type="url" placeholder={p.placeholder} value={social[p.key]} onChange={e => this.handleSocialChange(p.key, e.target.value)} disabled={loadingTabSave} />
                        </div>
                    ))}
                </div>
                <div style={S.saveRow}><button style={S.saveBtn} onClick={() => this.handleSocialSave()} disabled={loadingTabSave}>{loadingTabSave ? 'Saving...' : 'Save Social Links'}</button></div>
            </>
        );
    }

    renderPromoLinksTab() {
        const { promoLinks, promoForm, loadingTabSave, deleteModal, createdUserId } = this.state;
        return (
            <>
                <h2 style={S.sectionTitle}>Promo Links</h2>
                <div style={{ background: 'rgba(255,255,255,0.03)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '8px', padding: '20px', marginBottom: '24px' }}>
                    <p style={{ ...S.label, fontSize: '14px', color: '#ffffff', marginBottom: '16px', fontWeight: '600' }}>Add New Promo Link</p>
                    <div style={S.row} className="cr-row">
                        <div style={S.field}><label style={S.label}>Plan Name</label><input style={S.input} type="text" placeholder="Plan name" value={promoForm.plan} onChange={e => this.handlePromoFormChange('plan', e.target.value)} /></div>
                        <div style={S.field}><label style={S.label}>Promo Code</label><input style={S.input} type="text" placeholder="e.g. SUMMER20" value={promoForm.code} onChange={e => this.handlePromoFormChange('code', e.target.value)} /></div>
                        <div style={S.field}><label style={S.label}>Price</label><input style={S.input} type="text" placeholder="e.g. $9.99" value={promoForm.price} onChange={e => this.handlePromoFormChange('price', e.target.value)} /></div>
                    </div>
                    <div style={{ ...S.row, gridTemplateColumns: '2fr 1fr' }} className="cr-promo-url-row">
                        <div style={S.field}><label style={S.label}>URL</label><input style={S.input} type="url" placeholder="https://..." value={promoForm.url} onChange={e => this.handlePromoFormChange('url', e.target.value)} /></div>
                        <div style={{ display: 'flex', alignItems: 'flex-end' }}><button style={S.saveBtn} onClick={() => this.addPromoLink()}>Add Link</button></div>
                    </div>
                </div>
                {promoLinks.length > 0 ? (
                    <div className="cr-table-wrap">
                    <table style={S.promoTable}>
                        <thead>
                            <tr>
                                {['Plan', 'Code', 'Price', 'URL', 'Created', ''].map(h => <th style={S.promoTh} key={h}>{h}</th>)}
                            </tr>
                        </thead>
                        <tbody>
                            {promoLinks.map(link => (
                                <tr key={link.id}>
                                    <td style={S.promoTd}>{link.plan}</td>
                                    <td style={S.promoTd}><code style={{ background: 'rgba(255,255,255,0.08)', padding: '2px 6px', borderRadius: '4px' }}>{link.code}</code></td>
                                    <td style={S.promoTd}>{link.price}</td>
                                    <td style={S.promoTd}><a href={link.url} target="_blank" rel="noreferrer" style={{ color: 'var(--highlight, #e9c548)', textDecoration: 'none', fontSize: '12px' }}>Open ↗</a></td>
                                    <td style={S.promoTd}>{link.createdAt ? new Date(link.createdAt).toLocaleDateString() : ''}</td>
                                    <td style={S.promoTd}><button style={S.btnDanger} onClick={() => this.removePromoLink(link.id)}>Remove</button></td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    </div>
                ) : (
                    <p style={{ color: '#777', fontSize: '14px', textAlign: 'center', padding: '32px 0' }}>No promo links yet. Add one above.</p>
                )}
                {createdUserId && (
                    <div style={S.saveRow}>
                        <button style={S.saveBtn} onClick={() => this.handlePromoSave()} disabled={loadingTabSave}>
                            {loadingTabSave ? 'Saving...' : 'Save Promo Links'}
                        </button>
                    </div>
                )}

                {/* Delete confirmation modal */}
                {deleteModal.show && (
                    <div style={S.modal} onClick={() => this.setState({ deleteModal: { show: false, id: null } })}>
                        <div style={S.modalBox} onClick={e => e.stopPropagation()}>
                            <h3 style={S.modalTitle}>Remove Promo Link</h3>
                            <p style={S.modalBody}>Are you sure you want to remove this promo link?</p>
                            <div style={S.modalFooter}>
                                <button style={S.btnSecondary} onClick={() => this.setState({ deleteModal: { show: false, id: null } })}>Cancel</button>
                                <button style={{ ...S.btnPrimary, background: '#dc2626' }} onClick={() => this.confirmRemovePromoLink()}>Remove</button>
                            </div>
                        </div>
                    </div>
                )}
            </>
        );
    }

    renderTabContent() {
        switch (this.state.activeTab) {
            case 'personal':    return this.renderPersonalTab();
            case 'company':     return this.renderCompanyTab();
            case 'team':        return this.renderTeamTab();
            case 'addresses':   return this.renderAddressesTab();
            case 'paymentinfo': return this.renderPaymentInfoTab();
            case 'graphics':    return this.renderGraphicsTab();
            case 'social':      return this.renderSocialTab();
            case 'promolinks':  return this.renderPromoLinksTab();
            default:            return this.renderPersonalTab();
        }
    }

    render() {
        const { activeTab, showUserRequiredModal, showSuccessModal, successEmail, toast } = this.state;
        const token = getToken();
        return (
            <React.Fragment>
                <style>{`
                    @media (max-width: 768px) {
                        .cr-row { grid-template-columns: 1fr !important; }
                        .cr-row2 { grid-template-columns: 1fr !important; }
                        .cr-graphics-grid { grid-template-columns: 1fr !important; }
                        .cr-promo-url-row { grid-template-columns: 1fr !important; }
                        .cr-body { padding: 20px !important; }
                        .cr-tab-bar { padding: 0 8px !important; top: 58px !important; }
                        .cr-tab-bar button { padding: 10px 20px !important; font-size: 14px !important; }
                        .cr-header-row { flex-wrap: wrap; gap: 10px; margin-bottom: 16px; }
                        .cr-table-wrap { overflow-x: auto; -webkit-overflow-scrolling: touch; }
                        .cr-phone-row { flex-wrap: nowrap; }
                        .cr-code-select { width: 90px !important; }
                    }
                    @media (max-width: 480px) {
                        .cr-body { padding: 20px !important; }
                        .cr-tab-bar button { padding: 10px 20px !important; font-size: 14px !important; }
                    }
                `}</style>
                <div className="recording_page">
                    <Header />
                    <div style={S.page}>
                        {token && (
                        <div style={S.tabBar} className="cr-tab-bar">
                            {TABS.map(t => (
                                <button key={t.key} style={S.tabBtn(activeTab === t.key)} onClick={() => this.handleTabClick(t.key)}>
                                    {t.label}
                                </button>
                            ))}
                        </div>)}
                        <div style={S.body} className="cr-body">
                            {token ? null : (
                                <div style={{ ...S.headerRow, marginBottom: '24px' }} className="cr-header-row">
                                    <h1 style={S.h1}>Become a Creator</h1>
                                </div>
                            )}
                            {this.renderTabContent()}
                        </div>
                    </div>
                    <Footer />
                </div>

                {showSuccessModal && (
                    <div style={S.modal}>
                        <div style={{ ...S.modalBox, maxWidth: '460px', textAlign: 'center' }} onClick={e => e.stopPropagation()}>
                            <div style={{ fontSize: '48px', marginBottom: '12px' }}>🎉</div>
                            <h3 style={{ ...S.modalTitle, fontSize: '22px' }}>You're registered as a Creator!</h3>
                            <p style={{ ...S.modalBody, marginBottom: '12px' }}>
                                Your creator account has been successfully created.
                            </p>
                            <p style={{ ...S.modalBody, marginBottom: '24px' }}>
                                Please <strong style={{ color: '#ffffff' }}>log in using your registered email address</strong> to manage your creator profile.
                            </p>
                            {successEmail ? (
                                <div style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)', borderRadius: '8px', padding: '12px 20px', marginBottom: '24px', fontSize: '15px', color: 'var(--highlight, #e9c548)', fontWeight: '700', wordBreak: 'break-all' }}>
                                    {successEmail}
                                </div>
                            ) : null}
                            <div style={S.modalFooter}>
                                <button style={{ ...S.btnPrimary, padding: '10px 32px', fontSize: '14px' }} onClick={() => this.setState({ showSuccessModal: false })}>Got it</button>
                            </div>
                        </div>
                    </div>
                )}

                {showUserRequiredModal && (
                    <div style={S.modal} onClick={() => this.setState({ showUserRequiredModal: false })}>
                        <div style={S.modalBox} onClick={e => e.stopPropagation()}>
                            <h3 style={S.modalTitle}>User Required</h3>
                            <p style={S.modalBody}>Please fill in and save the <strong>Personal Information</strong> tab before accessing other sections.</p>
                            <div style={S.modalFooter}>
                                <button style={S.btnSecondary} onClick={() => this.setState({ showUserRequiredModal: false })}>Cancel</button>
                                <button style={S.btnPrimary} onClick={() => this.setState({ showUserRequiredModal: false, activeTab: 'personal' })}>Go to Personal</button>
                            </div>
                        </div>
                    </div>
                )}

                <div style={S.toast(toast.show, toast.type)}>{toast.message}</div>
            </React.Fragment>
        );
    }
}

export default CreatorPage;
